import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-refresh"
export default class extends Controller {
  static values = { 
    interval: { type: Number, default: 30000 }, // 30 seconds default
    url: String,
    enabled: { type: Boolean, default: true }
  }

  connect() {
    console.log("Auto-refresh controller connected")
    this.startRefresh()
  }

  disconnect() {
    this.stopRefresh()
  }

  startRefresh() {
    if (this.enabledValue && this.urlValue) {
      this.refreshTimer = setInterval(() => {
        this.refresh()
      }, this.intervalValue)
      
      console.log(`Auto-refresh started: ${this.intervalValue}ms interval`)
    }
  }

  stopRefresh() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
      console.log("Auto-refresh stopped")
    }
  }

  refresh() {
    if (!this.enabledValue) return

    console.log("Auto-refreshing data...")
    
    fetch(this.urlValue, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      }
      throw new Error(`HTTP error! status: ${response.status}`)
    })
    .then(html => {
      if (html.trim()) {
        Turbo.renderStreamMessage(html)
        console.log("Data refreshed successfully")
      }
    })
    .catch(error => {
      console.error('Auto-refresh error:', error)
      // Optionally stop auto-refresh on repeated errors
    })
  }

  // Manual refresh trigger
  manualRefresh(event) {
    if (event) {
      event.preventDefault()
    }
    
    // Add loading indicator
    const button = event?.currentTarget
    if (button) {
      const originalText = button.innerHTML
      button.disabled = true
      button.innerHTML = '<i class="bi bi-arrow-clockwise"></i> 刷新中...'
      
      setTimeout(() => {
        button.disabled = false
        button.innerHTML = originalText
      }, 1000)
    }
    
    this.refresh()
  }

  // Toggle auto-refresh
  toggle(event) {
    this.enabledValue = !this.enabledValue
    
    if (this.enabledValue) {
      this.startRefresh()
    } else {
      this.stopRefresh()
    }
    
    // Update toggle button text
    const button = event?.currentTarget
    if (button) {
      button.textContent = this.enabledValue ? '停止自动刷新' : '启动自动刷新'
      button.className = this.enabledValue ? 
        'btn btn-warning btn-sm' : 
        'btn btn-success btn-sm'
    }
    
    console.log(`Auto-refresh ${this.enabledValue ? 'enabled' : 'disabled'}`)
  }

  // Update interval
  updateInterval(newInterval) {
    this.intervalValue = newInterval * 1000 // Convert to milliseconds
    
    if (this.enabledValue) {
      this.stopRefresh()
      this.startRefresh()
    }
    
    console.log(`Auto-refresh interval updated to ${this.intervalValue}ms`)
  }
}
